(function() {
  const sectionName = 'ugc-slider';

  if (sectionName in Shopify.theme.sections.registered) {
    const sections = document.querySelectorAll(`[data-section-type=${sectionName}]`);

    sections.forEach((section, index) => {
      if (index !== 0) {
        const linkTag = section.querySelector('link');
        const scriptTag = section.querySelector('script');

        linkTag.remove();
        scriptTag.remove();
      }
    });
  } else {
    const tabsArray = document.querySelectorAll('.ugcSlider__headerList .ugcSlider__headerListItem');
    const iconsArray = document.querySelectorAll('.ugcSlider__itemListIcon--openView');

    function toggleQuickView(target) {
      const currentList = target.closest('.ugcSlider__item').querySelector('.ugcSlider__itemList');

      currentList.classList.toggle('ugcSlider__itemList--active');
    }

    iconsArray.forEach((icon) => {
      icon.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleQuickView(e.currentTarget);
      });
    });

    document.addEventListener('DOMContentLoaded', function() {
      $('.ugcSlider__products--slider').each(function(index, gallery) {
        $(this).on('init', function (event, slick) {
          changeProgressBar(slick, 0, this);
        })
      });

      $('.ugcSlider__products--slider').each(function() {
        $(this).slick(sliderSettings)
      });

      $('.ugcSlider__products--slider').each(function(index, gallery) {
        $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          changeProgressBar(slick, nextSlide, this);
        })
      });

      toggleVariant();

      tabsArray.forEach(tab => {
        tab.addEventListener('click', (event) => {
          toggleTab(event);
        });
      });

      function toggleTab(e) {
        let currentWrapper = e.currentTarget.closest('.ugcSlider__wrapper'),
            activeTab = currentWrapper.querySelector('.ugcSlider__headerList .active--tab'),
            activeSlider = currentWrapper.querySelector('.ugcSlider__productsWrapper.ugcSlider__productsWrapper--active'),
            currentEvent = e.currentTarget,
            currentSlider = currentWrapper.querySelector(`.ugcSlider__productsWrapper[data-product-slider="${e.currentTarget.dataset.productTag}"]`);

        activeTab.classList.remove('active--tab');
        currentEvent.classList.add('active--tab');
        activeSlider.classList.remove('ugcSlider__productsWrapper--active');
        currentSlider.classList.add('ugcSlider__productsWrapper--active');
      }

      function toggleVariant() {
        let sectionVariants = document.querySelectorAll('.collectionSlider .quick-add__size');

        sectionVariants.forEach(variant => {
          variant.addEventListener('click', (event) => {
            let currentVariant = event.currentTarget,
                currentProduct = currentVariant.closest('.product'),
                currentButtonsArray = currentProduct.querySelectorAll('.collectionFullpageProduct__contentFooterButton span'),
                productActiveTab = currentProduct.querySelector('.quick-add__size--active');

            if (productActiveTab) {
              productActiveTab.classList.remove('quick-add__size--active');
              currentVariant.classList.add('quick-add__size--active');
            } else {
              currentVariant.classList.add('quick-add__size--active');
            }

            currentButtonsArray.forEach(button => {
              button.dataset.id = currentVariant.dataset.id;
              button.dataset.inventoryQuantity = currentVariant.dataset.inventoryQuantity;
            });
          });
        });
      }

      function changeProgressBar(slick, nextSlide, slider) {
        let calc = ((nextSlide + 1) / (slick.slideCount - 2)) * 100;
        let progressBar = $(slider).next();

        if(window.outerWidth <= 640) {
          calc = ((nextSlide + 1) / (slick.slideCount)) * 100;
        }

        progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
      }
    });
  }

  Shopify.theme.sections.register(sectionName);
})();
